import React from "react";

export const OPERATION_HELP_TITLE = "Operações";

export function OperationHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Aqui você <strong>cria e acompanha
        operações</strong> de campo — plantio, pulverização, preparo de solo,
        transporte e outras atividades ligadas às máquinas da fazenda.
      </p>
      <p>
        Este é um dos <strong>campos mais importantes da plataforma</strong>.
        Depois que uma operação é criada e vinculada a uma máquina, você passa a
        ver, neste mesmo fluxo:
      </p>
      <ul>
        <li>
          <strong>Rastreamento</strong> da máquina no mapa
        </li>
        <li>
          <strong>Velocidade</strong> e deslocamento
        </li>
        <li>
          <strong>Horário de início e fim</strong> do trabalho
        </li>
        <li>
          Produtos, talhões, operador e demais informações da atividade
        </li>
      </ul>
      <p>
        <strong>Como criar uma operação (visão geral):</strong>
      </p>
      <ol>
        <li>
          Entre em <strong>Operações</strong> e clique em{" "}
          <strong>Nova operação</strong>.
        </li>
        <li>
          <strong>Passo 1 — Tipo de operação:</strong> escolha ou cadastre o
          tipo (ex.: pulverização, plantio).
        </li>
        <li>
          <strong>Passo 2 — Envolvidos:</strong> selecione a{" "}
          <strong>máquina</strong> (e implemento, quando aplicável).
        </li>
        <li>
          <strong>Passo 3 — Quando:</strong> informe data e horário — inclusive{" "}
          <strong>data retroativa</strong>, se o trabalho já começou e você está
          registrando depois.
        </li>
        <li>
          <strong>Passo 4 — Resumo:</strong> confira os dados e salve.
        </li>
      </ol>
      <p>
        <strong>Data retroativa:</strong> use quando a máquina já estava
        trabalhando e você precisa registrar a operação com o período correto no
        passado. A plataforma passa a exibir rastros e indicadores conforme as
        datas informadas.
      </p>
      <p>
        <strong>Exemplo prático:</strong> crie uma operação de pulverização,
        escolha o trator <em>100.015</em>, defina início às 06:30 e fim às
        11:45. Depois de salva, abra a operação para ver no mapa o percurso, a
        velocidade e o tempo real de trabalho da máquina naquele intervalo.
      </p>
      <p>
        <strong>O que acontece depois:</strong> a operação fica disponível na
        lista, no painel da fazenda e nos relatórios — pronta para consulta,
        acompanhamento e cruzamento com ordens de serviço e rastreamento.
      </p>
    </>
  );
}
